import {Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {ClickOutsideDirective} from '../../directives/click-outside.directive';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.less']
})
export class DropdownComponent implements OnInit {

  @Input() dropdownLabel: string;
  @Input() showAny: boolean;
  @Input() fieldName: string;
  @Input() colorStyle: string;
  @Input() sourceList: any[];
  @Input() upperDropdown: boolean;
  @Input() disabled = false;
  @Input() showOneLine = false;

  // @ViewChild ('dropDownList') dropDownList: ElementRef;
  // @ViewChild ('dropdownPop') dropdownPop: ElementRef;

  @Output() userChoice: EventEmitter<string> = new EventEmitter<string>();

  dropdown: boolean;

  constructor() {
  }

  ngOnInit() {
    this.dropdown = false;
    if (this.showAny === undefined) {
      this.showAny = true;
    }
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
    }
  }

  toggleDropdown() {
    if (!this.disabled) {
      this.dropdown = !this.dropdown;
    }
  }

  changeLabel(s) {
    if (s === 'Any') {
      this.dropdownLabel = s;
    } else {
      if (this.fieldName === undefined || this.fieldName === '') {
        this.dropdownLabel = s;
      } else {
        this.dropdownLabel = s[this.fieldName];
      }
    }
    this.userChoice.emit(s);
  }

  checkActive(s) {
    if (this.fieldName === undefined) {
      return s === this.dropdownLabel;
    } else {
      return  s[this.fieldName]  ===  this.dropdownLabel
    }
  }


  setDefaultDropdownLabel(s: string) {
    this.dropdownLabel = s;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown/dropdown.component.ts